<template>
  <q-form @submit="this.onSubmit" class="ms-form ms-form--narrow">
    <div class="ms-form-grid ms-form-grid--single">
      <div>
        <CustomSelect
          :options="this.entranceOptions"
          label="Подъезд"
          optionValueKey="entrance"
          optionLabelKey="entrance"
          :value="this.formData.entrance || ''"
          @change="(value) => onChange('entrance', value)"
        />
      </div>
      <div>
        <CustomSelect
          :options="this.floorOptions"
          label="Этаж"
          optionValueKey="floor"
          optionLabelKey="floor"
          :value="this.formData.floor || ''"
          @change="(value) => onChange('floor', value)"
        />
      </div>
      <div>
        <CustomCheckbox
          color="primary"
          label="Активный"
          :value="!!this.formData.is_active"
          @change="(value) => onChange('is_active', value)"
        />
      </div>
    </div>
    <CustomModalFooter :btn-loading="this.loading" />
  </q-form>
</template>
<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import { getFloorOptions } from "./services";
import CustomCheckbox from "@/components/form/CustomCheckbox";

export default {
  name: "flat-common-area-upd",
  components: { CustomCheckbox, CustomSelect, CustomModalFooter },
  props: ["data"],
  data() {
    return {
      entranceOptions: this.data?.entranceOptions || [],
      floorOptions: [],
      loading: false,
      steps: [],
      formData: {
        flat_id: this.data?.body?.flat_id || "",
        resident_id: this.data?.resident_id || "",
        entrance: this.data?.body?.entrance || "",
        floor: this.data?.body?.floor || "",
        is_active: this.data?.body?.is_active || false,
      },
    };
  },
  methods: {
    async onChange(key, value) {
      this.formData[key] = value;
      if (key === "entrance") {
        this.getFloors();
        if (!this.floorOptions.length) {
          this.formData.floor = "";
        }
      }
    },
    async onSubmit() {
      this.loading = true;
      this.formData.entrance = Number(this.formData.entrance);
      this.formData.floor = Number(this.formData.floor);
      await this.data?.onSubmit(this.formData);
      this.loading = false;
    },
    async getFloors() {
      const body = {
        resident_id: this.formData.resident_id,
        entrance: this.formData.entrance,
      };
      const res = await getFloorOptions(body);
      this.floorOptions = res || [];
    },
  },
  mounted() {
    if (this.formData.entrance) {
      this.getFloors();
    }
  },
};
</script>
